/**
 * ZoneNav — shell de navegación para las "zonas" con pestañas (Cuenta,
 * Trabajo). Resultados y Plan pasaron a shells propios (encabezado +
 * pestañas horizontales) porque necesitaban una forma que esto no tiene —
 * ver PlanLayout.jsx/ResultadosLayout.jsx.
 *
 * v8.5.39 · F2 · antes cada zona era una fila de pastillas horizontales
 * arriba del título, lo que en desktop dejaba la pantalla sin encabezado
 * claro. En sm+ pasa a una columna de navegación de 200px con borde a la
 * derecha (patrón lista de sección); en mobile se mantienen las pastillas
 * horizontales — ahí no entra una columna fija de 200px.
 *
 * v8.5.60 · piel · activo pasa a fondo --ink/texto --surface — "mismo
 * lenguaje que el sidebar" (Sidebar.jsx usa exactamente ese tratamiento para
 * su ítem activo). La columna de escritorio se apoya sobre --paper (el
 * fondo de la app detrás del sidebar), no transparente: se lee como una
 * superficie de navegación propia, igual que el sidebar.
 */
import { Link, Outlet } from "react-router-dom";

export default function ZoneNav({ items }) {
  return (
    <div className="sm:flex sm:gap-8">
      <div className="flex items-center gap-2 overflow-x-auto pb-3 mb-4 -mx-1 px-1 scrollbar-hide sm:hidden">
        {items.map(t => (
          <Link
            key={t.to}
            to={t.to}
            className={`flex-shrink-0 flex items-center gap-1.5 px-4 h-10 rounded-full text-sm font-extrabold whitespace-nowrap transition-colors ${
              t.active
                ? "bg-[var(--ink)] text-[var(--surface)]"
                : "bg-[var(--surface)] text-[var(--ink-3)] hover:bg-[var(--line)]"
            }`}
          >
            <t.icon className="h-4 w-4"/> {t.label}
          </Link>
        ))}
      </div>

      <nav className="hidden sm:block sm:w-[200px] sm:flex-shrink-0 sm:pr-4 sm:pl-1 sm:py-1">
        <div className="flex flex-col gap-0.5">
          {items.map(t => (
            <Link
              key={t.to}
              to={t.to}
              className={`flex items-center gap-2.5 px-3.5 h-11 rounded-[16px] text-[15px] transition-colors ${
                t.active
                  ? "bg-[var(--ink)] text-[var(--surface)] font-extrabold"
                  : "text-[var(--ink-2)] font-semibold hover:bg-[var(--line)]"
              }`}
            >
              <t.icon className="h-4 w-4"/> {t.label}
            </Link>
          ))}
        </div>
      </nav>

      <div className="flex-1 min-w-0 sm:pl-6">
        <Outlet/>
      </div>
    </div>
  );
}
